import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.resendMessage.loading;
export const selectErrorMessage = (state: RootState) =>
  state.resendMessage.error;
export const resendMessageDataResponse = (state: RootState) =>
  state.resendMessage.resendMessageResponse;
